import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { verifyRedirect } from "../../../../Service/RM";
import { CommonImages } from "../../../../reusableUI/images";
import Lottie from "lottie-react";

const VerificationRedirect = () => {
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState("Verifying...");
  const [showLoader, setShowLoader] = useState(false);
  const calledRef = useRef(false);

  useEffect(() => {
    if (calledRef.current) return;
    calledRef.current = true;

    const searchParams = new URLSearchParams(location.search);
    const code = searchParams.get("code");
    const state = searchParams.get("state");
    const error = searchParams.get("error_description");

    verifyRedirect(code, state, error)
      .then((res) => {
        console.log("API response:", res);
        if (res?.error === false) {
          console.log("Verified successfully:", res?.data);
          window.location.href = res?.data?.url;
        } else {
          console.error("Verification failed", res?.error);
        }
      })
      .catch((err) => {
        console.error("API call failed", err);
      });
  }, [location.search]);

  return (
    <div className="flex flex-1 min-h-screen bg-[#F9F9F9] items-center justify-center px-4 py-6">
      <div className="flex flex-col items-center relative b-10">
        <Lottie
          animationData={CommonImages.loadLottie}
          loop
          className="w-40 h-40 sm:w-48 sm:h-48"
        />
        <div className="w-full max-w-[400px] flex flex-col items-center gap-4 mt-2">
          <p className="text-center text-[16px] sm:text-[18px] font-semibold text-[#161616] font-poppins">
            We're redirecting you...
          </p>
          <p className="text-center text-[13px] sm:text-[14px] text-[#696969] font-poppins">
            Please wait, this may take a few seconds.
          </p>
        </div>
      </div>
    </div>
  );
};

export default VerificationRedirect;
